import { IconButton, List, ListItem, Tooltip } from '@mui/material';

import { useSidebarContext, useToggleSidebarHandler } from './SidebarContext';
import type { MenuProps } from './types';
import MenuItem from './MenuItem';
import { IconCollapseLeft, IconCollapseRight } from '@vs-online-only-app/ui';

function Menu({ items }: MenuProps) {
  const { isOpen } = useSidebarContext();
  const toggleSidebar = useToggleSidebarHandler();

  return (
    <List role="menu">
      <ListItem>
        <Tooltip title={isOpen ? 'Collapse' : 'Expand'} placement="right" arrow>
          <IconButton onClick={toggleSidebar} sx={{ borderRadius: 1 }}>
            {isOpen ? <IconCollapseLeft /> : <IconCollapseRight />}
          </IconButton>
        </Tooltip>
      </ListItem>
      {items.map((item) => (
        <MenuItem key={item.id} {...item} />
      ))}
    </List>
  );
}

export default Menu;
